import { render } from "./asociate-permissions.html?vue&type=template&id=927cd86a&scoped=true&ts=true"
import script from "./asociate-permissions.ts?vue&type=script&lang=ts"
export * from "./asociate-permissions.ts?vue&type=script&lang=ts"

import "./asociate-permissions.scss?vue&type=style&index=0&id=927cd86a&scoped=true&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Seguridad\\seguridad-adminlte-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-927cd86a"]])

export default __exports__